import { Phone, ExternalLink } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, TECH_EMERGENCY_URL } from "../../data/site";

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-slate-900">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6">
                <div className="max-w-md">
                    <div className="flex items-center gap-3 mb-2">
                        <img src="/logo-icon-white.png" alt="" className="w-10 h-10 object-contain shrink-0" />
                        <p className="font-heading text-base font-semibold text-white">Computer Repairs Semaphore</p>
                    </div>
                    <p className="text-xs leading-relaxed text-slate-400 mt-1.5">
                        Friendly onsite computer repairs and IT support for homes and small businesses in Semaphore
                        SA 5019 and Adelaide's western suburbs.
                    </p>
                </div>
                <div className="text-sm space-y-1.5">
                    <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-1.5 text-white font-semibold hover:text-orange-300 transition-colors">
                        <Phone className="w-4 h-4 text-orange-400" /> {PHONE_DISPLAY}
                    </a>
                    <a
                        href={TECH_EMERGENCY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-tech-emergency-link"
                        className="flex items-center gap-1.5 text-xs text-slate-400 hover:text-white transition-colors"
                    >
                        <ExternalLink className="w-3.5 h-3.5" /> Operated by Tech Emergency
                    </a>
                </div>
            </div>
            <div className="border-t border-slate-800 mt-6 pt-4 pb-16 md:pb-0 text-xs text-slate-500">
                © {new Date().getFullYear()} Computer Repairs Semaphore — Operated by Tech Emergency, Adelaide SA.
            </div>
        </div>
    </footer>
);
